import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import styles from "./ApplyCloseEntityNameCell.module.scss";

export const ApplyCloseEntityNameCell = memo(function ApplyCloseEntityNameCell({
    row,
    getValue,
}: CellContext<
    ViewTableFeatures,
    ApplyCloseTemplateEntitySelectionRow,
    string
>) {
    const item = row.original;
    const cellValue = getValue();

    if (item.isClientRow) {
        return (
            <ViewTableCell>
                <span>{cellValue}</span>
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell>
            <div className={styles.entityName}>
                <EntityAvatar
                    size="xs"
                    entity={{
                        name: item.name,
                        iconColor: item.iconColor,
                        logo: item.logo,
                    }}
                    aria-hidden
                />
                <span className={styles.nameText}>{cellValue}</span>
            </div>
        </ViewTableCell>
    );
});
